import Swiper from 'swiper';
import {Navigation, Autoplay} from 'swiper/modules';

// import 'swiper/css';
// import 'swiper/css/navigation';

export default class SliderSquare {
    constructor() {
        const $sections = document.querySelectorAll('section.slider-square');

        $sections.forEach($section => {
            const swiper = new Swiper($section.querySelector('.swiper'), {
                // configure Swiper to use modules
                modules: [Navigation, Autoplay],
                autoplay: {
                    delay: 2000,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                    disabledClass: 'swiper-button-disabled border !text-primary-darker border-primary-darker !bg-white',
                },
                slidesPerView: 1.2,
                spaceBetween: 15,
                centerInsufficientSlides: true,
                breakpoints: {
                    640: {
                        slidesPerView: 2.5,
                        spaceBetween: 32,
                    },
                }
            });
        });
    }
}

new SliderSquare();